import { render, staticRenderFns } from "./SelectTmpDialog.vue?vue&type=template&id=bb0a8920&scoped=true&"
import script from "./SelectTmpDialog.vue?vue&type=script&lang=js&"
export * from "./SelectTmpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0a8920",
  null
  
)

export default component.exports